import React from 'react';

const LoadingSpinner = ({ isLoading }) => {
  if (!isLoading) return null;
  
  return (
    <div className="loading-overlay">
      <div className="loading-spinner-container">
        <div className="spinner"></div>
        <div className="loading-text">กำลังโหลด...</div>
      </div>
    </div>
  );
};

export default LoadingSpinner